import { render, staticRenderFns } from "./Switchbar.vue?vue&type=template&id=5f22ed88&scoped=true&"
import script from "./Switchbar.vue?vue&type=script&lang=js&"
export * from "./Switchbar.vue?vue&type=script&lang=js&"
import style0 from "./Switchbar.vue?vue&type=style&index=0&id=5f22ed88&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f22ed88",
  null
  
)

export default component.exports